<template>
  <div class="all-replay-wrapper flex">
    <a href="javascript:;">
      <UserAvatar :src="curComment.userInfo.headImgUrl" :shape="shape" />
    </a>
    <div class="comment-wrapper">
      <div class="comment-info">
        <div class="comment-top">
          <a href="javascript:;">
            <span class="user-name">{{
              curComment.userInfoExtend || curComment.userInfo.name
            }}</span>
          </a>
          <span :class="commentClassName">：{{ initCommentContent }}</span>
        </div>
        <div class="comment-bottom flex">
          <span class="create-time">{{ date }}</span>
          <p class="handle-wrapper" v-if="operationBtn">
            <el-button
              class="handle-action"
              :disabled="buttonCondition"
              ref="handleBtn"
              @click="handleAction"
              >{{ operationText }}</el-button
            >
            <span
              class="handle-icon"
              :class="praiseCondition"
              @click="praiseComment"
            ></span>
            <span class="handle-count">{{ initPraiseCount }}</span>
          </p>
        </div>
        <div class="reply-area" v-show="displayInput" v-if="notMine">
          <div class="input-wrapper">
            <el-input
              type="textarea"
              resize="none"
              maxlength="100"
              show-word-limit
              :autosize="{ minRows: 2 }"
              :placeholder="inputHolder"
              v-model="replyContent"
            >
            </el-input>
          </div>
          <div class="reply-wrapper flex">
            <span></span>
            <el-button
              class="send-reply"
              :disabled="forbidReply"
              @click="submitReply"
              >发送</el-button
            >
          </div>
        </div>
        <div class="reply-list-wrapper">
          <ReplyItem
            v-for="(item, index) in replyList"
            :key="index"
            :reply="item"
            :deleteStatus="item.isDeleted"
            :showStatus="item.isShow"
            :showScene="replyScene"
            @updateReplyList="pushReplyList"
            @handleRemove="removeReply"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import UserAvatar from "../../components/UserAvatar";
import { getFullDate } from "../../utils/date";
import { tranNumber } from "../../utils/feed";
import ReplyItem from "./reply-item";
import { apiMap } from "../../utils/apiMap";
export default {
  name: "all-reply",
  props: {
    curComment: Object,
    replyList: Array,
  },
  components: {
    UserAvatar,
    ReplyItem,
  },
  data() {
    return {
      replyTotal: 0,
      curReplyPage: 1,
      shape: "terse",
      replyContent: "",
      forbidReply: true,
      displayInput: false,
      praised: false,
      notMine: false,
      operationBtn: true,
      dialogVisible: false,
      replyScene: "allReplyList",
    };
  },
  computed: {
    ...mapGetters(["user"]),
    totalPage() {
      return this.replyTotal;
    },
    date() {
      return getFullDate(new Date(this.curComment.created_at * 1000));
    },
    inputHolder() {
      return `回复${this.curComment.userInfoExtend ||
        this.curComment.userInfo.name}`;
    },
    initPraiseCount() {
      return tranNumber(this.curComment.praise);
    },
    praiseCondition() {
      if (this.curComment.praiseStatus == 1) {
        return "praised";
      } else {
        return "unpraise";
      }
    },
    buttonCondition() {
      if (this.curComment.userId !== this.user.userId) {
        return false;
      } else {
        return true;
      }
    },
    commentClassName() {
      if (this.curComment.isDeleted == 1 || this.curComment.isShow == 0) {
        return `withdrawn-text`;
      } else {
        return `comment-text`;
      }
    },
    operationText() {
      if (this.curComment.userId !== this.user.userId) {
        this.notMine = true;
        return "回复";
      } else {
        this.notMine = false;
        return "删除";
      }
    },
    initCommentContent() {
      if (this.deleteStatus == 1) {
        this.operationBtn = false;
        return `[该评论已删除]`;
      } else if (this.showStatus == 0) {
        this.operationBtn = false;
        return `[该评论已被系统屏蔽]`;
      } else {
        this.operationBtn = true;
        return this.curComment.content;
      }
    },
  },
  methods: {
    getReplyList(start) {
      let $this = this;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["replyList"]["method"],
          url: apiMap["replyList"]["url"],
          data: `commentId=${this.curComment.id}&start=${start}&count=10`,
        })
        .then(function(response) {
          // response.data.result.count 总回复条数
          // response.data.result.data.commentData 回复的父级评论
          // response.data.result.data.replyData 回复列表
          if (response.data.result.statusCode == 1) {
            $this.replyTotal = response.data.result.count;
            response.data.result.data.replyData.forEach((item) => {
              $this.replyList.push(item);
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    praiseComment() {
      if (this.curComment.praiseStatus == 1) {
        if (this.curComment.praise > 0) {
          this.curComment.praise -= 1;
        }
        this.curComment.praiseStatus = 0;
      } else {
        this.curComment.praise += 1;
        this.curComment.praiseStatus = 1;
      }
    },
    handleAction(e) {
      if (this.curComment.userId !== this.user.userId) {
        if (e.target.innerText == "回复") {
          e.target.innerText = "取消";
          this.displayInput = true;
        } else {
          e.target.innerText = "回复";
          this.displayInput = false;
        }
      } else {
        this.$emit("handleDelete", this.curComment.id);
      }
    },
    submitReply() {
      let $this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["replyComment"]["method"],
          url: apiMap["replyComment"]["url"],
          data: `token=${loginUser.token}&commentId=${this.curComment.id}&commentUserId=${this.curComment.userId}&content=${this.replyContent}`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            var myReply = {
              commentId: response.data.result.data.commentId,
              commentUserId: $this.curComment.userId,
              content: $this.replyContent,
              created_at: Math.round(new Date() / 1000),
              id: $this.curComment.id,
              isDeleted: 0,
              isShow: 1,
              praiseStatus: 0,
              replyToUserInfo: $this.curComment.userInfo,
              replyToUserInfoExtend: null,
              replyUserInfo: {
                headImgUrl: loginUser.headImgUrl,
                name: loginUser.nickName,
                realName: null,
                thumbHeadImg: loginUser.thumbHeadImg,
              },
              replyUserInfoExtend: loginUser.nickName,
              updated_at: null,
              userId: loginUser.userId,
            };
            $this.replyList.push(myReply);
            $this.replyContent = "";
            $this.$refs.handleBtn.click();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    pushReplyList(commentID, data) {
      var aimIndex = -1;
      this.replyList.filter((item, index) => {
        if (item.id == commentID) {
          aimIndex = index;
        }
      });
      if (aimIndex != -1) {
        this.replyList.splice(aimIndex + 1, 0, data);
      }
    },
    // renewalThisPage() {
    //     this.$emit('resetReplyList');
    // },
    removeReply(replyID) {
      var findIndex = -1;
      this.replyList.filter((item, index) => {
        if (item.id == replyID) {
          findIndex = index;
        }
      });
      if (findIndex != -1) {
        this.replyList.splice(findIndex, 1);
      }
    },
  },
  watch: {
    replyContent(text) {
      if (text === "" || text.trim().length === 0) {
        this.forbidReply = true;
      } else {
        this.forbidReply = false;
      }
    },
  },
};
</script>
<style scoped>
.comment-item {
  position: relative;
  padding: 4px;
}

.comment-item:not(:last-child):after {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  margin: 0 20px;
  border-bottom: 1px solid #f6f6f6;
  content: "";
}

.comment-info {
  margin-left: 5px;
}

.comment-top {
  line-height: 22px;
}

.comment-top a {
  color: #1a70db;
}

.comment-bottom {
  width: 96%;
  line-height: 20px;
  justify-content: space-between;
}

.reply-list-wrapper,
.reply-area,
.reply-info {
  width: 96%;
}

.comment-bottom .create-time {
  color: #999;
}

.handle-wrapper {
  line-height: 20px;
}

.handle-action {
  display: none;
  margin-right: 15px;
  padding: 0;
  color: #1a70db;
  background-color: #fff;
  border: none;
}

.comment-item:hover .handle-action {
  display: inline-block;
}

.handle-icon {
  position: relative;
  top: 3px;
  display: inline-block;
  width: 19px;
  height: 17px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: contain;
}

.handle-count {
  margin-left: 5px;
  color: #e74f52;
}

.unpraise {
  background-image: url("../../assets/icon/cl_feed_praise.png");
}

.praised {
  background-image: url("../../assets/icon/cl_feed_praised.png");
}

.input-wrapper {
  margin: 4px 0;
}

.input-wrapper .el-textarea__inner {
  min-height: 50px;
}

.reply-wrapper {
  justify-content: space-between;
}

.send-reply {
  padding: 4px 10px;
}

.withdrawn-text {
  color: #999;
}
</style>
